
import I18n from '../../../translations/i18n';

export function initPlasticRedemption() {
  if ($('.plastic-redemption').length == 0) {
    return;
  }

  redeemPlasticFormErrorMessageListener();
};



function redeemPlasticFormErrorMessageListener() {
  var requiredFields = $('.plastic-redemption input:required');
  requiredFields.each(function(index, element) {
    var redemption = $(element)[0];
    var redemptionError = $(element).closest('.error-wrapper').find('span.error')[0];
    var redemptionErrorText = $(element).closest('.error-wrapper').find('span.error .error-text')[0];
    
    redemption.addEventListener('change', function (event) {
      redemptionErrorText.innerHTML = ''; // Reset the content of the message
      if(!redemption.validity.valid) {
        $('.plastic-redemption .confirm-redemption-btn').addClass('disabled-btn').removeClass('primary-btn');
        showPlasticError(redemption, redemptionErrorText, redemptionError);
        event.preventDefault();
      } else {
        checkAllValidPlastic();
        redemptionError.className = 'error';
      }
    });
    

  });
}


function showPlasticError(redemption, redemptionErrorText, redemptionError) {
  if (redemption.validity.valueMissing) {
    redemptionErrorText.textContent = I18n.t('views.dashboards.cash_back_page.plastic.form_1.error.text_1');
  }

  // Set the styling appropriately
  redemptionError.className = 'error active';
  checkAllValidPlastic();
  
}

function checkAllValidPlastic() {
  // Check to see if everything is filled in
  var numberValid = 0;
  var requiredFields = $('.plastic-redemption input:required');
  
  requiredFields.each(function(index, element) {
    var redemption = $(element)[0];
    if(redemption.validity.valid) {
      numberValid += 1;
    } 
  });

  if (numberValid == $('.plastic-redemption input:required').length) {
    $('.plastic-redemption .confirm-redemption-btn').addClass('primary-btn').removeClass('disabled-btn');
  } else {
    $('.plastic-redemption .confirm-redemption-btn').removeClass('primary-btn').addClass('disabled-btn');
  }
}
